var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIce(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 210,
    height: 297,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("title", null, "Layer 1"), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    strokeWidth: 50,
    id: "layer1"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "g1983"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    strokeWidth: 0.03403,
    fill: "#0000ff",
    ry: 66.8229,
    rx: 71.0372,
    cy: 138.7292,
    cx: 316.38843,
    id: "path31-6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0.03201,
    fill: "#ffffff",
    d: "m290.21577,95.84989l-1.83699,3.93739l6.75621,10.86155l-12.01587,-0.0298l-2.40672,4.06822l2.06037,3.09637l16.98395,0.4445l10.33299,16.88205l-20.54785,-0.03788l-8.01702,-13.24823l-4.75705,-0.05556l-1.89981,3.34388l6.10271,9.91395l-14.16806,0.10102l-2.39705,3.75606l2.55814,3.79697l13.25843,0l-6.60639,8.83653l2.30845,4.4016l5.21456,0.06567l7.89943,-13.25227l20.8056,0.10102l-10.1676,15.39296l-16.27783,-0.06567l-2.78153,4.5304l2.51358,3.48885l11.60455,0.01162l-6.78843,11.06865l2.56405,4.343l5.45673,0.01162l6.39053,-10.413l4.80968,8.62186l5.20811,0.32328l2.66984,-4.22026l-7.64114,-12.9593l9.49585,-15.48237l8.85417,14.46405l-8.23235,13.21085l2.76864,4.54252l4.46762,-0.30307l5.83691,-9.42954l6.77017,11.07471l5.28275,0.09092l2.75038,-4.43696l-6.37227,-10.41907l10.34158,0.40915l2.9061,-4.07984l-2.53881,-4.28491l-15.74891,-0.28792l-9.82233,-15.30659l19.52492,0.04849l7.40863,13.22449l4.86606,-0.03586l2.73803,-4.03337l-5.99317,-9.20729l13.18218,0.04849l2.48082,-4.22986l-2.58822,-3.47521l-13.2203,0.00606l5.93356,-9.76191l-2.57533,-3.89395l-3.8834,0.03788l-8.79134,13.62303l-19.29778,-0.03788l10.20466,-16.63l15.71347,0.11618l2.01956,-3.67726l-1.96371,-3.58634l-11.12557,-0.24751l6.42651,-10.54029l-2.55439,-4.29249l-4.52669,0.39399l-6.49309,10.86155l-6.05814,-9.84222l-4.88915,0.197l-1.95136,3.18578l8.05407,14.10895l-9.74554,15.78594l-10.62242,-16.9957l7.91822,-12.47237l-2.18978,-3.6419l-4.37849,-0.17174l-5.85678,9.00474l-6.32609,-10.65344l-5.38585,-0.10102l-0.00215,0.00606z",
    id: "rect2830-5"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "g3555"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    strokeWidth: 0.03403,
    fill: "#f2f2f2",
    ry: 66.8229,
    rx: 71.0372,
    cy: 138.7292,
    cx: 529.50003,
    id: "path31-6-7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0.00198,
    fillRule: "evenodd",
    fill: "#0000ff",
    d: "m550.51612,143.96944c0,10.61505 -9.42014,19.23085 -21.01448,19.23085c-11.60455,0 -21.22766,-8.61782 -21.01448,-19.23085c0.27923,-14.23624 11.83921,-20.03499 21.01448,-36.39778c9.74017,15.82635 21.01448,25.78223 21.01448,36.39778z",
    id: "path2530"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "g3560"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    strokeWidth: 0.03403,
    fill: "#f2f2f2",
    ry: 66.8229,
    rx: 71.0372,
    cy: 138.7292,
    cx: 742.61163,
    id: "path31-6-7-5"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0.00198,
    fillRule: "evenodd",
    fill: "#0000ff",
    d: "m777.35278,151.56389c0,10.61505 -9.42067,19.23085 -21.01448,19.23085c-11.60508,0 -21.22766,-8.61782 -21.01448,-19.23085c0.27923,-14.23624 11.83921,-20.03499 21.01448,-36.39778c9.73964,15.82635 21.01448,25.78223 21.01448,36.39778z",
    opacity: 0.69855,
    id: "path2530-6"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0.00147,
    fillRule: "evenodd",
    fill: "#0000ff",
    d: "m729.75378,118.3539c0,7.85761 -6.97315,14.23574 -15.5556,14.23574c-8.59051,0 -15.71401,-6.37964 -15.55614,-14.23574c0.20405,-10.53827 8.76395,-14.83077 15.55614,-26.94349c7.20995,11.7157 15.5556,19.08537 15.5556,26.94349z",
    opacity: 0.69855,
    id: "path2530-6-1"
  })), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "g3573"
  }, /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "g3566"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    strokeWidth: 0.03403,
    fill: "#f2f2f2",
    ry: 66.8229,
    rx: 71.0372,
    cy: 138.7292,
    cx: 955.72323,
    id: "path31-6-7-5-2"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0.00198,
    fillRule: "evenodd",
    fill: "#0000ff",
    d: "m976.73932,165.99359c0,10.61455 -9.42014,19.23034 -21.01448,19.23034c-11.60455,0 -21.22766,-8.61782 -21.01448,-19.23034c0.27923,-14.23675 11.83921,-20.0355 21.01448,-36.39829c9.74017,15.82635 21.01448,25.78273 21.01448,36.39829z",
    opacity: 0.69855,
    id: "path2530-6-7"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0.00147,
    fillRule: "evenodd",
    fill: "#0000ff",
    d: "m943.67299,116.83501c0,7.85761 -6.97368,14.23574 -15.55614,14.23574c-8.59051,0 -15.71347,-6.37964 -15.55614,-14.23574c0.20405,-10.53827 8.76449,-14.83127 15.55614,-26.94349c7.20995,11.7157 15.55614,19.08537 15.55614,26.94349z",
    opacity: 0.69855,
    id: "path2530-6-1-0"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "null",
    strokeWidth: 0.00095,
    fillRule: "evenodd",
    fill: "#0000ff",
    d: "m992.21223,124.36278c0,5.10018 -4.44722,9.24012 -9.9206,9.24012c-5.47875,0 -10.02155,-4.14096 -9.92113,-9.24012c0.12887,-6.84081 5.58936,-9.62704 9.92113,-17.4892c4.59811,7.60455 9.9206,12.38802 9.9206,17.4892z",
    opacity: 0.69855,
    id: "path2530-6-1-0-9"
  }))), /*#__PURE__*/React.createElement("g", {
    stroke: "null",
    id: "g7384"
  }, /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    strokeWidth: 0.03403,
    fill: "#0000ff",
    ry: 66.8229,
    rx: 71.0372,
    cy: 138.72914,
    cx: 103.27683,
    id: "path31"
  }), /*#__PURE__*/React.createElement("ellipse", {
    stroke: "null",
    strokeWidth: 0.06615,
    fill: "#ffffff",
    ry: 13.36458,
    rx: 14.20744,
    cy: 167.28331,
    cx: 103.27683,
    id: "path277"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    strokeWidth: 0.29581,
    fill: "#ffffff",
    y: 100.46041,
    x: 96.17309,
    height: 66.82287,
    width: 14.20744,
    id: "rect406"
  }), /*#__PURE__*/React.createElement("rect", {
    stroke: "null",
    strokeWidth: 0.13609,
    fill: "#0000ff",
    y: 140.55414,
    x: 98.98104,
    height: 23.388,
    width: 8.59159,
    id: "rect406-3"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    strokeWidth: 0.39687,
    fill: "#0000ff",
    r: 6.2458,
    cy: 167.28331,
    cx: 103.27683,
    id: "path532"
  }), /*#__PURE__*/React.createElement("circle", {
    stroke: "null",
    strokeWidth: 0.26458,
    fill: "#ffffff",
    r: 4.16387,
    cy: 101.29355,
    cx: 103.27683,
    id: "path7264"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "svg_2",
    height: 0,
    width: 3,
    y: 137.5,
    x: 348,
    stroke: "#000",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIce);
export default __webpack_public_path__ + "static/media/ice.18a9f5d64e8877d345b17453b078e6db.svg";
export { ForwardRef as ReactComponent };